import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-639a80d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "content-otp-page",
  class: "mb-8"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title-2" }, "OTP認証", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ご希望の日時は、既に他の予約で埋まっております。", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "再度、日時選択ボタンより、ご希望日時をお選びください。", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "grid" }
const _hoisted_8 = { class: "col-8" }
const _hoisted_9 = { class: "col-4" }
const _hoisted_10 = {
  key: 0,
  class: "col-12"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "OTP が再送信されました。受信トレイを確認してください。", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"info\" data-v-639a80d0><p class=\"font-bold text-sm\" data-v-639a80d0>入力されたメールアドレスはすでにシステムに登録されているものです。</p><p data-v-639a80d0> このメールアドレスがご自身のものであることを確認するために、次の手順でワンタイムパスワードによる認証を行なってください。 </p><p data-v-639a80d0> ※メールアドレスに送信されたワンタイムパスワードを確認して入力してください。<br data-v-639a80d0> ※ワンタイムパスワードを正確に入力することで、既存の情報を上書きする処理が進行します。 </p><p data-v-639a80d0><span class=\"font-bold text-sm\" data-v-639a80d0>※注意事項</span><br data-v-639a80d0> ・認証が完了することで、現在登録されている個人情報が新しく入力された情報に上書きされます。<br data-v-639a80d0> ・上書き後の情報は元に戻すことができませんので、ご入力内容に間違いがないことを再度ご確認ください。 </p><p data-v-639a80d0> Re;COMa（レコマ）サポートチーム<br data-v-639a80d0> ＝＝＝＝＝＝＝＝＝＝＝＝＝<br data-v-639a80d0> 〒220-0004<br data-v-639a80d0> 神奈川県横浜市西区北幸2丁目10番27号<br data-v-639a80d0> 東武立野ビル402<br data-v-639a80d0> 代表番号 ： 045-577-9151<br data-v-639a80d0> ▼official Site<br data-v-639a80d0><a href=\"https://re-coma.net/\" data-v-639a80d0>https://re-coma.net/</a><br data-v-639a80d0> ＝＝＝＝＝＝＝＝＝＝＝＝＝ </p></div>", 1)
const _hoisted_14 = { class: "controller-wrapper" }

import { useStore } from "vuex";
import { ref, computed } from "vue";
import { get, set } from "@vueuse/core";
import Message from "primevue/message";
import { useToast } from "primevue/usetoast";
import RouterUtils from "@/common/utils/router.util";
import RouterConstants from "@/customer/constants/router.constants";
import { OtpServices } from "@/customer/services";
import { notityErrorMsg } from "@/clinic/utils/notify-utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'OtpForm',
  setup(__props) {

const store = useStore();
const toast = useToast();

const errorsObject = ref({});
const otpCode = ref();
const isNoticeVisible = ref(false);

const disableSubmitButton = computed(() => {
  return get(otpCode) == "" || !/^\d{6}$/.test(get(otpCode));
});

const back = () => {
  store.commit("booking/setOtpCode", undefined);
  RouterUtils.goTo(RouterConstants.PERSONAL_INFO_ROUTER_NAME);
};

const resendOtp = async () => {
  const params = {
    clinic_id: store.getters["line_account/clinicId"],
    line_account_id: store.getters["line_account/id"],
    customer_email: store.getters["booking/customerInfo"].email,
  };
  await OtpServices.resend(
    params,
    () => set(isNoticeVisible, true),
    () => notityErrorMsg(toast, "OTP の再送信に失敗しました。")
  );
};

const accept = () => {
  store.commit("booking/setOtpCode", get(otpCode));
  store.dispatch("booking/submitBooking", {
    success: () => {
      store.commit("booking/setEditFlag", false);
      RouterUtils.goTo(RouterConstants.BOOKING_SUCCESS_ROUTER_NAME);
    },
    error: error => {
      set(errorsObject, error.response.data.errors);
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (errorsObject.value.step)
      ? (_openBlock(), _createBlock(_unref(Message), {
          key: 0,
          class: "errors mb-5",
          severity: "error",
          closable: false
        }, {
          default: _withCtx(() => [
            (errorsObject.value.step == 'booking_time')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_3,
                  _hoisted_4
                ], 64))
              : (errorsObject.value.step == 'partner')
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "エラーが発生しました。詳細についてはクリニックにお問い合わせください。"))
                : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(errorsObject.value.message), 1))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_InputText, {
          class: "input-text",
          modelValue: otpCode.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((otpCode).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Button, {
          class: "btn w-full text-white",
          onClick: resendOtp,
          label: "再送信"
        })
      ]),
      (isNoticeVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
        : _createCommentVNode("", true)
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_Button, {
        class: "btn cancel-btn w-full",
        onClick: back
      }, {
        default: _withCtx(() => [
          _createTextVNode("戻る")
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "btn accept-btn w-full",
        onClick: accept,
        disabled: _unref(disableSubmitButton)
      }, {
        default: _withCtx(() => [
          _createTextVNode("受け入れる")
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})